import React from 'react';

/* Translations */
import { useTranslation } from 'react-i18next';

/* Styled Components */
import {
  PermissionItem,
  PermissionTitle,
  PermissionText,
} from './styles/DefaultPermissions';

/* Hooks */
import useDefaultPermissions from 'hooks/settings/useDefaultPermissions';

interface DefaultPermissionsProps {
  role: string;
}

const DefaultPermissions: React.FC<DefaultPermissionsProps> = ({ role }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const defaultPermissions = useDefaultPermissions(language, role);

  return (
    <>
      {defaultPermissions.map((item: string, index: number) => {
        return (
          <PermissionItem key={index}>
            <PermissionTitle>
              {t(
                'settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.PERMISSIONS.PERMISSION',
              )}
              {' '}
              {index + 1}
            </PermissionTitle>
            <PermissionText>{item}</PermissionText>
          </PermissionItem>
        );
      })}
    </>
  );
};

export default DefaultPermissions;
